import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  CommonAutoCompleteInput,
  CommonButton,
  CommonDatePicker,
  CommonFlexContainer,
  CommonHeaderPage,
  CommonSelect,
  CommonStyledPageContent,
  CommonTextArea,
  CommonTextMedium,
  CommonTimePicker,
  CommonTextCustomSize,
} from "../../../../../components/common/AtomCommonComponents";
import { Col, Empty, Form, Row } from "antd";
import { CommonFormItemWithLabel } from "../../../../../components/common/MoleculesCommonComponent";
import ValidationUtils from "../../../../../utils/ValidationUtils";
import SelectMarketModal from "../modals/SelectMarketModal";
import CustomerService from "../../../../../services/api/CustomerService";
import TextFormatUtils from "../../../../../utils/TextFormatUtils";
import {
  AddEditAddressModalType,
  SelectedCustomerHomeDeliver,
} from "../../../../../types/types";
import HomeDeliveryService from "../../../../../services/api/HomeDeliveryService";
import { useHistory } from "react-router-dom";
import DialogUtils from "../../../../../utils/DialogUtils";
import TellerService from "../../../../../services/api/TellerService";
import AddEditAddressModal from "../../../../../components/common/modals/AddEditAddressModal";
import {
  FixPaymentOption,
  initialAddressModalState,
} from "../../../../../utils/PatternUtils";
import { RangePickerProps } from "antd/lib/date-picker";
import moment from "moment";
import AddEditCustomerModal from "../../../../customer/modals/AddEditCustomerModal";
import ProgramsService from "../../../../../services/api/ProgramService";
import { StyledHomeDeliveryDivider } from "../components/StyledHomeMedicaidComponent";
import BoxesService from "../../../../../services/api/BoxesService";
import AddBoxModal from "../modals/AddBoxModal";
import MedicaidService from "../../../../../services/api/MedicaidService";

const AddMedicaidDeliveryView = () => {
  //initialize
  const [selectedBranch, setSelectedBranch] = useState({
    value: "",
    label: "Home Delivery",
  });
  const [paymentMethodOptions, setPaymentMethodOptions] = useState<any[]>([]);
  const [branchesData, setBranchesData] = useState([
    { label: "Home Delivery", value: "0" },
  ]);
  const [addDataAddressModal, setAddDataAddressModal] =
    useState<AddEditAddressModalType>(initialAddressModalState());
  const [selectedDiscounts, setSelectedDiscounts] = useState<any[]>([]);
  const [selectedBox, setSelectedBox] = useState<any>(null);
  const [selectedSubBox, setSelectedSubBox] = useState<any>(null);
  const [editData, setEditData] = useState<any | null>(null);
  const [autoDates, setAutoDates] = useState<any[]>([]);

  const [isSelectMarketModalVisible, setisSelectMarketModalVisible] =
    useState<boolean>(false);
  const [isCartModalVisible, setIsCartModalVisible] = useState<boolean>(false);
  const [isAddressModalVisible, setIsAddressModalVisible] =
    useState<boolean>(false);
  const [isAddCustomerModalVisible, setIsAddCustomerModalVisible] =
    useState<boolean>(false);
  const [isAddEditBoxModalVisible, setIsAddEditBoxModalVisible] =
    useState<boolean>(false);

  const [optionsCustomer, setOptionsCustomer] = useState();
  const [selectedCustomer, setSelectedCustomer] =
    useState<SelectedCustomerHomeDeliver | null>(null);
  const [orderSummaryList, setOrderSummeryList] = useState<any[]>([]);

  const [programs, setPrograms] = useState();

  const [form] = Form.useForm();

  const customerService = useMemo(() => new CustomerService(), []);
  const medicaidService = useMemo(() => new MedicaidService(), []);
  const tellerService = useMemo(() => new TellerService(), []);
  const programService = useMemo(() => new ProgramsService(), []);

  const history = useHistory();

  useEffect(() => {
    fetchBranches();
  }, []);

  useEffect(() => {
    fetchDiscountsAndPaymentOptions();
  }, [selectedBranch]);

  useEffect(() => {
    const updateCustomerAddress = async () => {
      await medicaidService.updateCustomerAddress(
        selectedCustomer?._id!,
        addDataAddressModal
      );
    };

    if (addDataAddressModal.address_1 && selectedCustomer?._id) {
      form.setFieldsValue({ address: addDataAddressModal });
      updateCustomerAddress();
    }
  }, [addDataAddressModal]);

  const fetchBranches = async (): Promise<void> => {
    const result = await tellerService.getBranch();
    let branches = result.map(
      ({ _id, name }: { _id: string; name: string }) => ({
        value: _id,
        label: name,
      })
    );

    const homeDeliveryBranch = { value: "", label: "Home Delivery" };
    setBranchesData([homeDeliveryBranch, ...branches]);
  };

  const fetchDiscountsAndPaymentOptions = async (): Promise<void> => {
    const result = await medicaidService.getDiscounts(selectedBranch.value);

    const resultPaymentOptions = result.payment_option_discounts.map(
      (item: any) => {
        return {
          _id: item._id,
          label: item.name,
          value: item.value,
          discount_type: item.discount_type,
        };
      }
    );

    setPaymentMethodOptions(resultPaymentOptions);
  };

  const onCloseSelectMarketModal = () => {
    setisSelectMarketModalVisible(false);
  };

  const onCloseCartModal = () => {
    setIsCartModalVisible(false);
  };

  const onSubmitSelectedBranch = (branch: any) => {
    setSelectedBranch(branch);
  };

  const onSelectCustomerName = async (value: string) => {
    form.resetFields(["customer"]);
    const [customerDetails, result] = await Promise.all([
      customerService.getCustomerDetails(value),
      programService.getPrograms(),
    ]);
    if (
      customerDetails.address &&
      customerDetails.address.address_1 &&
      customerDetails.address.city
    ) {
      setAddDataAddressModal(customerDetails.address);
      form.setFieldsValue({ address: addDataAddressModal });
    } else {
      setAddDataAddressModal(initialAddressModalState());
      form.resetFields(["address"]);
    }

    if (customerDetails) {
      form.setFieldsValue({ customer: customerDetails });
      const programs = result.map(
        ({ _id, name }: { _id: string; name: string }) => ({
          value: _id,
          label: name,
          disabled: customerDetails?.programs?.some(
            (x: any) => x?.program_id?.toString() === _id.toString()
          ),
        })
      );
      const medicaidOnly = programs.filter(
        (p: any) => p.label?.toLowerCase() === "medicaid"
      );
      setPrograms(medicaidOnly);

      if (customerDetails?.programs?.length) {
        customerDetails.programs = customerDetails.programs.filter((cp: any) =>
          medicaidOnly.some(
            (mp: any) => mp.value?.toString() === cp.program_id?.toString()
          )
        );
      }

      form.setFieldsValue({
        customer: customerDetails,
        programs: customerDetails?.programs?.map(
          (item: any) => item.program_id
        ),
        address: customerDetails?.address,
      });

      const scheduleDetails = await medicaidService.getSingleSchedule(
        customerDetails._id
      );
      const orderDetails = await medicaidService.getOrderDataByCustomer(customerDetails._id)
      
      if (
        scheduleDetails.schedule &&
        scheduleDetails.schedule.type === "weekly"
      ) {
        try {
          const rawStart =
            (scheduleDetails.schedule.start_at &&
              (scheduleDetails.schedule.start_at.$date ||
          scheduleDetails.schedule.start_at)) ||
            null;
          const rawEnd =
            (scheduleDetails.schedule.end_at &&
              (scheduleDetails.schedule.end_at.$date ||
          scheduleDetails.schedule.end_at)) ||
            null;
          const targetDay = Number(scheduleDetails.schedule.day_of_week);

          if (rawStart && rawEnd && !isNaN(targetDay)) {
            const start = moment(rawStart).startOf("day");
            const end = moment(rawEnd).endOf("day");

            const completedDatesSet = new Set(
              (orderDetails.orders || [])
          .map((o: any) => o?.delivery_date_and_time)
          .filter(Boolean)
          .map((dt: string) => moment(dt).format("YYYY-MM-DD"))
            );

            let first = start.clone();
            while (first.day() !== targetDay) {
              first.add(1, "day");
              if (first.isAfter(end)) break;
            }

            const weeklyDates: string[] = [];
            for (let d = first.clone(); d.isSameOrBefore(end); d.add(7, "days")) {
              weeklyDates.push(d.format("YYYY-MM-DD"));
            }

            const weeklyDatesWithStatus = weeklyDates.map((date) => ({
              date,
              status: completedDatesSet.has(date) ? "completed" : null,
            }));

            setAutoDates(weeklyDatesWithStatus);
            
          } else {
            setAutoDates([]);
          }
        } catch (e) {
          DialogUtils.error("Failed generating weekly schedule dates");
          setAutoDates([]);
        }
      } else {
        setAutoDates([]);
      }
    }
    setSelectedCustomer(customerDetails);
  };

  const onSearchCustomerName = async (data: string) => {
    const result = await customerService.getCustomers(
      `${data}?program=Medicaid`
    );
    const customerOptionsData = result.map((item: any, index: number) => {
      return { label: item.value, value: item.id, key: index };
    });

    setAddDataAddressModal(initialAddressModalState());
    setOptionsCustomer(customerOptionsData);
    if (!data || selectedCustomer) {
      setSelectedCustomer(null);
    }
  };

  const onClearSearchName = () => {
    setSelectedCustomer(null);
    form.resetFields(["customer"]);
    form.resetFields(["address"]);
    setAddDataAddressModal(initialAddressModalState());
  };

  const calculateSubTotalPrice = (items: any) => {
    if (items == null) return 0;
    if (Array.isArray(items)) {
      return items.reduce((sum: number, item: any) => {
        if (!item) return sum;
        return sum + (item.total || 0);
      }, 0);
    }
    if (typeof items === "number") return items;
    if (typeof items === "string" && items.trim() !== "") {
      const num = Number(items);
      return isNaN(num) ? 0 : num;
    }
    return 0;
  };

  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    return current && current.startOf("day").isBefore(moment().startOf("day"));
  };

  const onSubmit = async () => {
    try {
      const formValues = await form.validateFields();
      const {
        address,
        delivery_notes,
        time,
        delivery_date,
        programs,
      } = formValues;

      const local_user = JSON.parse(localStorage.getItem("user")!);
      const teller = {
        _id: local_user._id,
        first_name: local_user.first_name,
        last_name: local_user.last_name,
      };

      let selectedPaymentMethod = selectedDiscounts
        .filter((item) => item.voucher_type === "payment")
        .map((item) => item.name);
      selectedPaymentMethod.push("Cash");

      const transformedProducts = (selectedBox?.products?.products || []).map(
        (prod: any) => {
          if (!prod || typeof prod !== "object") return prod;
          const { description, category, group, ...rest } = prod;
          let unitTotal = 0;

          if (prod.product_units) {
            if (Array.isArray(prod.product_units)) {
              unitTotal =
                prod.product_units.reduce(
                  (sum: number, u: any) => sum + (Number(u?.total) || 0),
                  0
                ) || 0;
            } else if (typeof prod.product_units === "object") {
              unitTotal = Number(prod.product_units.price) || 0;
            }
          }

          const seasonProductsSource =
            selectedSubBox?.box_season_products ||
            selectedBox?.box_season_products ||
            [];

          let productQuantity = 1;
          const matchedSeasonProduct = seasonProductsSource.find((sp: any) => {
            const spId = sp?.product_id ?? sp?._id;
            return spId?.toString?.() === prod?._id?.toString?.();
          });

          if (
            matchedSeasonProduct &&
            (matchedSeasonProduct.quantity !== undefined ||
              matchedSeasonProduct.qty !== undefined)
          ) {
            productQuantity =
              matchedSeasonProduct.quantity ?? matchedSeasonProduct.qty ?? 1;
          }

          return {
            ...rest,
            isTop: true,
            count: productQuantity,
            total: unitTotal,
          };
        }
      );

      await medicaidService.createOrder(
        selectedDiscounts,
        selectedPaymentMethod,
        selectedBranch.value,
        selectedCustomer?._id!,
        transformedProducts,
        teller,
        "delivery",
        "pending",
        delivery_date,
        time,
        delivery_notes,
        address.address_1 ? address : (selectedCustomer?.address as any),
        programs,
        selectedBox.price
      );

      const onOk = () => {
        history.push("/medicaid");
      };

      DialogUtils.success("Order has been successfully created.", onOk);
    } catch (error) {
      DialogUtils.error(`Failed to create order.: ${error}`);
    }
  };

  const onCloseAddressModal = () => {
    setIsAddressModalVisible(false);
  };

  const onSaveAddressHandler = () => {
    form.resetFields(["address"]);
  };

  const onCompleteAddCustomer = async (customer_id: any) => {
    const [customerDetails, result] = await Promise.all([
      customerService.getCustomerDetails(customer_id),
      programService.getPrograms(),
    ]);
    setAddDataAddressModal(initialAddressModalState());
    if (customerDetails && result) {
      const program = result.map(
        ({ _id, name }: { _id: string; name: string }) => ({
          value: _id,
          label: name,
          disabled: customerDetails?.programs?.some(
            (x: any) => x?.program_id?.toString() === _id.toString()
          ),
        })
      );
      setPrograms(program);
    }
    form.setFieldsValue({
      customer: customerDetails,
      programs: customerDetails?.programs?.map((item: any) => item.program_id),
    });

    if (customerDetails.address.address_1 && customerDetails.city) {
      form.setFieldsValue({ address: customerDetails.address });
    }

    setSelectedCustomer(customerDetails);
    setIsAddCustomerModalVisible(false);
  };

  const onCancelAddCustomer = () => {
    setIsAddCustomerModalVisible(false);
  };

  const onCompleteAddBox = (values: any) => {
    setIsAddEditBoxModalVisible(false);
    if (values.boxType) {
      setEditData(JSON.parse(JSON.stringify(values)));
      setSelectedBox(values);
    }
  };

  const onCancelAddBox = () => {
    setIsAddEditBoxModalVisible(false);
  };

  return (
    <>
      <CommonHeaderPage>
        <p>Medicaid Delivery Management</p>
      </CommonHeaderPage>
      <CommonStyledPageContent ishomedeliverymanagement>
        <CommonFlexContainer width="100%" spaceBetween alignCenter>
          <CommonTextMedium>Add New Order</CommonTextMedium>
          <CommonFlexContainer
            alignCenter
            justifyCenter
            margin="0px 0px 10px 0px"
          ></CommonFlexContainer>
          <CommonFlexContainer height="5px" width="20%"></CommonFlexContainer>
        </CommonFlexContainer>
        <StyledHomeDeliveryDivider marginbottom="15px" />
        <Form form={form} validateTrigger="onChange">
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <CommonTextCustomSize
                fontSize="14px"
                fontWeight="700"
                color="primary"
              >
                CUSTOMER INFORMATION
              </CommonTextCustomSize>
              <StyledHomeDeliveryDivider />
              <div id="select-customer">
                <CommonFormItemWithLabel
                  label={"Customer Name"}
                  name={"customer"}
                  rules={[
                    { required: true, message: "Customer Name is required." },
                  ]}
                >
                  <CommonFlexContainer spaceBetween alignCenter gap="10px">
                    <CommonAutoCompleteInput
                      maxTagCount={"responsive"}
                      getPopupContainer={() =>
                        document.getElementById("select-customer") as any
                      }
                      placeholder="Search Customer"
                      color="primary"
                      notFoundContent={
                        optionsCustomer && (
                          <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={"No Customer Found"}
                          />
                        )
                      }
                      value={
                        selectedCustomer
                          ? selectedCustomer?.full_name
                          : undefined
                      }
                      options={optionsCustomer}
                      onSelect={onSelectCustomerName as any}
                      onSearch={onSearchCustomerName}
                      onClick={() => {
                        onSearchCustomerName("");
                      }}
                      allowClear
                      onClear={onClearSearchName}
                    />
                    <CommonButton
                      background="primary"
                      color="white"
                      onClick={() => setIsAddCustomerModalVisible(true)}
                    >
                      Add Customer
                    </CommonButton>
                  </CommonFlexContainer>
                </CommonFormItemWithLabel>
              </div>

              <CommonFormItemWithLabel
                label={"Qualified Programs"}
                name={"programs"}
              >
                {selectedCustomer && (
                  <CommonSelect
                    getPopupContainer={() =>
                      document.getElementById("select") as HTMLElement
                    }
                    notFoundContent={
                      <Empty
                        style={{ marginTop: -20 }}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="No Qualified Program Found."
                      />
                    }
                    mode="multiple"
                    maxTagCount="responsive"
                    placeholder="Select Programs"
                    options={programs}
                    color="primary"
                    noIndent={true}
                    optionFilterProp="children"
                    filterOption={(input: any, option: any) =>
                      (
                        option!.label?.toLowerCase() as unknown as string
                      )?.includes(input?.toLowerCase())
                    }
                  />
                )}
              </CommonFormItemWithLabel>
            </Col>
            <Col span={16}>
              <CommonTextCustomSize
                fontSize="14px"
                fontWeight="700"
                color="primary"
              >
                DELIVERY INFORMATION
              </CommonTextCustomSize>
              <StyledHomeDeliveryDivider />

              <Row gutter={8}>
                <Col span={12}>
                  <CommonFormItemWithLabel
                    label={"Delivery Address"}
                    name={"address"}
                    required
                    rules={[
                      {
                        required: true,
                        message: "Delivery Address is required.",
                      },
                    ]}
                    errormargintop={
                      selectedCustomer?.address || selectedCustomer
                        ? undefined
                        : !addDataAddressModal.address_1
                        ? "-35px"
                        : undefined
                    }
                    errorpaddingleft={
                      selectedCustomer?.address || selectedCustomer
                        ? undefined
                        : !addDataAddressModal.address_1
                        ? "10px"
                        : undefined
                    }
                  >
                    {addDataAddressModal.address_1 ? (
                      <>
                        <CommonFlexContainer
                          isBorder
                          borderradius={selectedCustomer ? "15px" : "50px"}
                          padding={selectedCustomer ? "12px 12px 0px 12px" : ""}
                          width="95%"
                        >
                          <CommonTextCustomSize fontSize="14px" color="primary">
                            {TextFormatUtils.ellipsis(
                              TextFormatUtils.addressString(
                                addDataAddressModal
                              ) ?? "",
                              100
                            )}
                          </CommonTextCustomSize>
                        </CommonFlexContainer>
                        <CommonButton
                          background="primary"
                          color="white"
                          onClick={() => setIsAddressModalVisible(true)}
                          style={{ marginTop: 10 }}
                        >
                          Edit Address
                        </CommonButton>
                      </>
                    ) : selectedCustomer?.address?.address_1 ? (
                      <>
                        <CommonFlexContainer
                          isBorder
                          borderradius={selectedCustomer ? "15px" : "50px"}
                          padding={selectedCustomer ? "12px 12px 0px 12px" : ""}
                          width="95%"
                        >
                          <CommonTextCustomSize fontSize="14px" color="primary">
                            {TextFormatUtils.ellipsis(
                              TextFormatUtils.addressString(
                                selectedCustomer.address
                              ) ?? "",
                              100
                            )}
                          </CommonTextCustomSize>
                        </CommonFlexContainer>
                        <CommonButton
                          background="primary"
                          color="white"
                          onClick={() => setIsAddressModalVisible(true)}
                          style={{ marginTop: 10 }}
                        >
                          Edit Address
                        </CommonButton>
                      </>
                    ) : selectedCustomer?.address || selectedCustomer ? (
                      <CommonButton
                        background="primary"
                        color="white"
                        onClick={() => setIsAddressModalVisible(true)}
                      >
                        Add Address
                      </CommonButton>
                    ) : null}
                  </CommonFormItemWithLabel>
                </Col>

                <Col span={12}>
                  <Row gutter={8}>
                    <Col span={12}>
                      <div id="select-four">
                        <CommonFormItemWithLabel
                          label={"Delivery Date"}
                          name={"delivery_date"}
                          rules={[
                          {
                            required: true,
                            message: "Delivery Date is required.",
                          },
                          ]}
                        >
                          <CommonDatePicker
                          format={"MM-DD-YYYY"}
                          placeholder="Select Date"
                          disabled={selectedCustomer ? false : true}
                          disabledDate={disabledDate}
                          onChange={(value: any) => {
                            if (!value) return;

                            // Normalize autoDates to array of { date: 'YYYY-MM-DD', status: string | null }
                            const scheduleArr = (autoDates || [])
                            .map((d: any) => {
                              if (d && typeof d === "object" && "date" in d) {
                              return {
                                date: moment(d.date).format("YYYY-MM-DD"),
                                status: d.status ?? null,
                              };
                              }
                              return {
                              date: moment(d).format("YYYY-MM-DD"),
                              status: null,
                              };
                            })
                            .sort((a: any, b: any) =>
                              a.date.localeCompare(b.date)
                            );

                            const selectedDateStr = moment(value)
                            .startOf("day")
                            .format("YYYY-MM-DD");
                            const idx = scheduleArr.findIndex(
                            (o: any) => o.date === selectedDateStr
                            );
                            if (idx === -1) return;

                            const selectedObj = scheduleArr[idx];

                            if (selectedObj.status === null) {
                            const earlierUncompleted = scheduleArr
                              .slice(0, idx)
                              .some((o: any) => o.status === null);

                            if (earlierUncompleted) {
                                DialogUtils.confirm(
                                "You have skipped one or more previous schedules. Are you sure you want to proceed with the selected date?",
                                () => {
                                  form.setFieldsValue({ delivery_date: value });
                                },
                                () => {
                                  form.resetFields(["delivery_date"]);
                                }
                                );
                            }
                            }
                          }}
                          dateRender={(current: any) => {
                            const highlightedDates: (
                            | string
                            | Date
                            | moment.Moment
                            | { date: string; status?: string | null }
                            )[] = autoDates;

                            const normalizedHighlighted = new Set(
                            highlightedDates
                              .filter(
                              (d: any) =>
                                !(
                                d &&
                                typeof d === "object" &&
                                d.status === "completed"
                                )
                              )
                              .map((d: any) => {
                              const raw =
                                d &&
                                typeof d === "object" &&
                                "date" in d
                                ? d.date
                                : d;
                              return moment(raw)
                                .startOf("day")
                                .format("YYYY-MM-DD");
                              })
                            );

                            const isHighlighted = normalizedHighlighted.has(
                            current.startOf("day").format("YYYY-MM-DD")
                            );

                            return (
                            <div
                              style={{
                              borderRadius: "50%",
                              backgroundColor: isHighlighted
                                ? "#e6f7ff"
                                : undefined,
                              padding: "4px",
                              fontWeight: isHighlighted ? 600 : undefined,
                              border: isHighlighted
                                ? "1px solid #1890ff"
                                : undefined,
                              color: isHighlighted
                                ? "#1890ff"
                                : undefined,
                              }}
                            >
                              {current.date()}
                            </div>
                            );
                          }}
                          getPopupContainer={(triggerNode: HTMLElement) =>
                            triggerNode.parentNode as HTMLElement
                          }
                          />
                        </CommonFormItemWithLabel>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div id="select-five">
                        <CommonFormItemWithLabel
                          label={"Time"}
                          name={"time"}
                          rules={[
                            {
                              required: true,
                              message: "Delivery Time is required.",
                            },
                          ]}
                        >
                          <CommonTimePicker
                            use12Hours
                            format="h:mm A"
                            placeholder="Select Time"
                            getPopupContainer={(triggerNode: HTMLElement) =>
                              triggerNode.parentNode as HTMLElement
                            }
                          />
                        </CommonFormItemWithLabel>
                      </div>
                    </Col>
                  </Row>
                  <CommonFormItemWithLabel
                    label={"Delivery Notes"}
                    name="delivery_notes"
                    rules={[{ validator: ValidationUtils.validateInput }]}
                  >
                    <CommonTextArea
                      placeholder="Input Delivery Notes"
                      maxLength={200}
                      rows={5}
                      color="primary"
                    />
                  </CommonFormItemWithLabel>
                </Col>
              </Row>
            </Col>
          </Row>
          <StyledHomeDeliveryDivider marginbottom="10px" margintop="10px" />
          <CommonFlexContainer alignitems="start" width="100%" spaceBetween>
            <CommonButton
              background="primary"
              color="white"
              onClick={() => setIsAddEditBoxModalVisible(true)}
              disabled={selectedCustomer ? false : true}
            >
              {editData ? <span>Edit Box</span> : <span>Add Box</span>}
            </CommonButton>
          </CommonFlexContainer>
          <StyledHomeDeliveryDivider margintop="10px" marginbottom="20px" />
          {selectedBox ? (
            <>
              {(() => {
                const products =
                  selectedSubBox?.box_season_products ||
                  selectedBox?.box_season_products ||
                  [];
                return (
                  <>
                    <CommonTextCustomSize
                      fontSize="14px"
                      fontWeight="700"
                      color="primary"
                    >
                      Selected Products
                    </CommonTextCustomSize>
                    {products.length ? (
                      <div
                        style={{
                          width: "500px",
                          border: "1px solid #e5e5e5",
                          borderRadius: 8,
                          padding: 12,
                          marginBottom: 20,
                          background: "#fafafa",
                        }}
                      >
                        <Row style={{ fontWeight: 600, marginBottom: 6 }}>
                          <Col span={16}>
                            <CommonTextCustomSize
                              fontSize="13px"
                              color="primary"
                            >
                              Product Name
                            </CommonTextCustomSize>
                          </Col>
                          <Col span={8} style={{ textAlign: "right" }}>
                            <CommonTextCustomSize
                              fontSize="13px"
                              color="primary"
                            >
                              Quantity
                            </CommonTextCustomSize>
                          </Col>
                        </Row>
                        {products.map((p: any, idx: number) => (
                          <Row
                            key={p.product_id || idx}
                            style={{
                              padding: "4px 0",
                              borderTop: idx === 0 ? "none" : "1px solid #eee",
                            }}
                          >
                            <Col span={16}>
                              <CommonTextCustomSize
                                fontSize="13px"
                                color="primary"
                              >
                                {p.name}
                              </CommonTextCustomSize>
                            </Col>
                            <Col span={8} style={{ textAlign: "right" }}>
                              <CommonTextCustomSize
                                fontSize="13px"
                                color="primary"
                              >
                                {p.quantity}
                              </CommonTextCustomSize>
                            </Col>
                          </Row>
                        ))}
                      </div>
                    ) : (
                      <CommonTextCustomSize fontSize="13px" color="primary">
                        No products selected.
                      </CommonTextCustomSize>
                    )}
                  </>
                );
              })()}
              <Row style={{ width: "500px" }}>
                <Row style={{ width: "100%" }}>
                  <Col span={13}>
                    <CommonTextCustomSize
                      fontSize="14px"
                      fontWeight="700"
                      color="primary"
                    >
                      Subtotal:
                    </CommonTextCustomSize>
                  </Col>
                  <Col span={11}>
                    <CommonTextCustomSize
                      fontSize="14px"
                      fontWeight="700"
                      color="primary"
                    >
                      {"$" +
                        TextFormatUtils.formatNumberWithCommas(
                          calculateSubTotalPrice(
                            selectedSubBox
                              ? selectedSubBox?.price
                              : selectedBox?.price
                          ),
                          true
                        )}
                    </CommonTextCustomSize>
                  </Col>
                </Row>

                <Row style={{ width: "100%" }}>
                  <Col span={13}>
                    <CommonTextCustomSize
                      fontSize="14px"
                      fontWeight="700"
                      color="primary"
                    >
                      TOTAL AMOUNT:
                    </CommonTextCustomSize>
                  </Col>
                  <Col span={11}>
                    <CommonTextCustomSize
                      fontSize="16px"
                      fontWeight="700"
                      color="primary"
                    >
                      {"$" +
                        TextFormatUtils.formatNumberWithCommas(
                          calculateSubTotalPrice(
                            selectedSubBox
                              ? selectedSubBox?.price
                              : selectedBox?.price
                          ),
                          true
                        )}
                    </CommonTextCustomSize>
                  </Col>
                </Row>
              </Row>

              <CommonFlexContainer isJustifyRight gap="5px">
                <CommonButton
                  key="cancel"
                  onClick={() => history.push("/medicaid")}
                >
                  Cancel
                </CommonButton>
                <Form.Item>
                  <CommonButton
                    key="save"
                    color="white"
                    background="primary"
                    htmlType="submit"
                    onClick={onSubmit}
                  >
                    Place Order
                  </CommonButton>
                </Form.Item>
              </CommonFlexContainer>
            </>
          ) : null}
        </Form>
      </CommonStyledPageContent>
      <SelectMarketModal
        branchesData={branchesData}
        isSelectMarketModalVisible={isSelectMarketModalVisible}
        onCloseModal={onCloseSelectMarketModal}
        onSubmitSelectedMarket={onSubmitSelectedBranch}
      />
      <AddEditAddressModal
        title={"Customer"}
        isAddEditAddressModal={isAddressModalVisible}
        onCloseAddEditAddressModal={onCloseAddressModal}
        addDataModal={addDataAddressModal}
        mode={"add"}
        onSaveAddress={onSaveAddressHandler}
        setAddDataModal={setAddDataAddressModal}
      />
      <AddEditCustomerModal
        isAddEditCustomerModalVisible={isAddCustomerModalVisible}
        onCompleteModal={onCompleteAddCustomer}
        onCancelModal={onCancelAddCustomer}
      />
      <AddBoxModal
        isAddEditBoxModalVisible={isAddEditBoxModalVisible}
        onCompleteModal={onCompleteAddBox}
        onCancelModal={onCancelAddBox}
        editData={editData}
        customerData={selectedCustomer}
      />
    </>
  );
};

export default AddMedicaidDeliveryView;
